/* =========================================================
   BASEUS — Product Page JS  (bs-product-page.js)
   ========================================================= */
(function () {
  'use strict';

  // ── Gallery ────────────────────────────────────────────
  const thumbs = document.querySelectorAll('.bsp-thumb');
  const slides = document.querySelectorAll('.bsp-gallery__slide');

  thumbs.forEach(function (thumb) {
    thumb.addEventListener('click', function () {
      var idx = this.dataset.index;
      thumbs.forEach(function (t) { t.classList.remove('bsp-thumb--active'); });
      slides.forEach(function (s) { s.classList.remove('bsp-gallery__slide--active'); });
      this.classList.add('bsp-thumb--active');
      var activeSlide = document.querySelector('.bsp-gallery__slide[data-index="' + idx + '"]');
      if (activeSlide) activeSlide.classList.add('bsp-gallery__slide--active');
    });
  });

  // ── Tabs ───────────────────────────────────────────────
  var tabBtns     = document.querySelectorAll('.bsp-tab-btn');
  var tabContents = document.querySelectorAll('.bsp-tab-content');

  tabBtns.forEach(function (btn) {
    btn.addEventListener('click', function () {
      var tab = this.dataset.tab;
      tabBtns.forEach(function (b) { b.classList.remove('bsp-tab-btn--active'); });
      tabContents.forEach(function (c) { c.classList.remove('bsp-tab-content--active'); });
      this.classList.add('bsp-tab-btn--active');
      var content = document.getElementById('bsp-tab-' + tab);
      if (content) content.classList.add('bsp-tab-content--active');
    });
  });

  // ── Sticky bar on scroll ───────────────────────────────
  var stickyBar = document.getElementById('bsp-sticky-bar');
  if (stickyBar) {
    window.addEventListener('scroll', function () {
      if (window.scrollY > 600) {
        stickyBar.classList.add('bsp-sticky-bar--visible');
      } else {
        stickyBar.classList.remove('bsp-sticky-bar--visible');
      }
    }, { passive: true });
  }

  // ── Quantity selector ──────────────────────────────────
  document.querySelectorAll('.bsp-qty__btn').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var input = this.closest('.bsp-qty').querySelector('.bsp-qty__input');
      if (!input) return;
      var val = parseInt(input.value, 10) || 1;
      if (this.dataset.action === 'inc') val += 1;
      else val = Math.max(1, val - 1);
      input.value = val;
    });
  });

  // ── Variant picker ─────────────────────────────────────
  function getSelectedOptions() {
    var opts = {};
    document.querySelectorAll('.bsp-swatch--active').forEach(function (el) {
      opts[el.dataset.option] = el.dataset.value;
    });
    document.querySelectorAll('.bsp-variant-btn--active').forEach(function (el) {
      opts[el.dataset.option] = el.dataset.value;
    });
    return opts;
  }

  function formatMoney(cents) {
    var amount = Math.round(cents / 100);
    return '₺' + amount.toLocaleString('tr-TR');
  }


  function updateVariant() {
    var selected = getSelectedOptions();
    if (!window.bspVariants || !window.bspVariants.length) return;

    var variant = null;
    for (var i = 0; i < window.bspVariants.length; i++) {
      var v = window.bspVariants[i];
      var match = true;
      for (var pos in selected) {
        if (Object.prototype.hasOwnProperty.call(selected, pos)) {
          var idx = parseInt(pos, 10) - 1;
          if (v.options[idx] !== selected[pos]) { match = false; break; }
        }
      }
      if (match) { variant = v; break; }
    }

    if (!variant) return;

    // Update hidden variant id
    var variantIdInput = document.getElementById('bsp-variant-id');
    if (variantIdInput) variantIdInput.value = variant.id;

    // Update price
    var priceEl   = document.querySelector('.bsp-price');
    var compareEl = document.querySelector('.bsp-price--compare');
    var discountEl = document.querySelector('.bsp-discount-badge');
    var stickyPrice = document.querySelector('.bsp-sticky-bar__price');

    if (priceEl) priceEl.textContent = formatMoney(variant.price);
    if (stickyPrice) stickyPrice.textContent = formatMoney(variant.price);

    if (compareEl) {
      if (variant.compare_at_price && variant.compare_at_price > variant.price) {
        compareEl.textContent = formatMoney(variant.compare_at_price);
        compareEl.style.display = '';
        if (discountEl) {
          var pct = Math.round((1 - variant.price / variant.compare_at_price) * 100);
          discountEl.textContent = '%' + pct + ' İndirim';
          discountEl.style.display = '';
        }
      } else {
        compareEl.style.display = 'none';
        if (discountEl) discountEl.style.display = 'none';
      }
    }

    // Update stock
    var stockEl   = document.querySelector('.bsp-stock__text');
    var stockDot  = document.querySelector('.bsp-stock__dot');
    if (stockEl && stockDot) {
      if (variant.available) {
        stockDot.style.background  = 'var(--bsp-green)';
        stockEl.style.color        = 'var(--bsp-green)';
        stockEl.textContent        = 'Stokta — 2–4 iş günü kargo';
      } else {
        stockDot.style.background  = '#888';
        stockEl.style.color        = '#888';
        stockEl.textContent        = 'Stokta yok';
      }
    }
  }

  function updateOptionLabel(optionPos, value) {
    var label = document.querySelector('.bsp-option__selected[data-option="' + optionPos + '"]');
    if (label) label.textContent = value;
  }

  // Color swatches
  document.querySelectorAll('.bsp-swatch').forEach(function (swatch) {
    swatch.addEventListener('click', function () {
      var pos = this.dataset.option;
      document.querySelectorAll('.bsp-swatch[data-option="' + pos + '"]').forEach(function (s) {
        s.classList.remove('bsp-swatch--active');
      });
      this.classList.add('bsp-swatch--active');
      updateOptionLabel(pos, this.dataset.value);
      updateVariant();
    });
  });

  // Model / variant buttons
  document.querySelectorAll('.bsp-variant-btn').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var pos = this.dataset.option;
      document.querySelectorAll('.bsp-variant-btn[data-option="' + pos + '"]').forEach(function (b) {
        b.classList.remove('bsp-variant-btn--active');
      });
      this.classList.add('bsp-variant-btn--active');
      updateOptionLabel(pos, this.dataset.value);
      updateVariant();
    });
  });

  // ── Add to cart (AJAX) ─────────────────────────────────
  var addForm = document.getElementById('bsp-product-form');
  var addBtn  = document.querySelector('.bsp-add-btn');

  if (addForm && addBtn) {
    addForm.addEventListener('submit', function (e) {
      // Let "Hemen Satın Al" (checkout) submit normally
      if (e.submitter && e.submitter.name === 'checkout') return;
      e.preventDefault();

      var variantIdInput = document.getElementById('bsp-variant-id');
      var qtyInput       = document.querySelector('.bsp-qty__input');
      if (!variantIdInput) return;

      var variantId = variantIdInput.value;
      var qty       = parseInt((qtyInput ? qtyInput.value : '1'), 10) || 1;

      addBtn.disabled = true;

      // Collect cart-items-component section IDs so theme can re-render them
      var cartSectionIds = [];
      document.querySelectorAll('cart-items-component[data-section-id]').forEach(function (el) {
        cartSectionIds.push(el.dataset.sectionId);
      });

      var formData = new FormData();
      formData.append('id', variantId);
      formData.append('quantity', qty);
      if (cartSectionIds.length) formData.append('sections', cartSectionIds.join(','));

      fetch('/cart/add.js', {
        method:  'POST',
        headers: { 'Accept': 'application/json' },
        body:    formData
      })
        .then(function (res) { return res.json(); })
        .then(function (cartResponse) {
          addBtn.classList.add('bsp-add-btn--added');
          addBtn.textContent = '✓ Sepete Eklendi!';

          // Dispatch the event the theme's cart drawer / cart-items-component listens for
          document.dispatchEvent(new CustomEvent('cart:update', {
            bubbles: true,
            detail: {
              resource: cartResponse,
              sourceId: variantId,
              data: {
                sections: cartResponse.sections || {}
              }
            }
          }));

          setTimeout(function () {
            addBtn.classList.remove('bsp-add-btn--added');
            addBtn.textContent = 'Sepete Ekle';
            addBtn.disabled    = false;
          }, 2200);
        })
        .catch(function () {
          addBtn.disabled = false;
        });
    });
  }

  // Sticky bar "Sepete Ekle" triggers main form
  var stickyAddBtn = document.querySelector('.bsp-sticky-bar__btn');
  if (stickyAddBtn && addBtn) {
    stickyAddBtn.addEventListener('click', function () {
      addBtn.click();
    });
  }

  // ── Lightbox ───────────────────────────────────────────
  var lightbox  = document.getElementById('bsp-lightbox');
  var lbImg     = lightbox && lightbox.querySelector('.bsp-lightbox__img');
  var lbPrev    = lightbox && lightbox.querySelector('.bsp-lightbox__prev');
  var lbNext    = lightbox && lightbox.querySelector('.bsp-lightbox__next');
  var lbCounter = lightbox && lightbox.querySelector('.bsp-lightbox__counter');
  var lbImages  = [];
  var lbIndex   = 0;

  document.querySelectorAll('.bsp-gallery__slide[data-full]').forEach(function(slide, i) {
    lbImages.push({ src: slide.dataset.full, alt: slide.dataset.alt || '', idx: i });
  });

  function lbRender() {
    if (!lbImg || !lbImages.length) return;
    lbImg.style.transition = 'none';
    lbImg.style.opacity = '0';
    lbImg.src = lbImages[lbIndex].src;
    lbImg.alt = lbImages[lbIndex].alt;
    lbImg.onload = function() {
      lbImg.style.transition = 'opacity 0.2s';
      lbImg.style.opacity = '1';
    };
    if (lbCounter) {
      lbCounter.textContent = (lbIndex + 1) + ' / ' + lbImages.length;
      lbCounter.style.display = lbImages.length > 1 ? '' : 'none';
    }
    if (lbPrev) lbPrev.style.display = lbImages.length > 1 ? '' : 'none';
    if (lbNext) lbNext.style.display = lbImages.length > 1 ? '' : 'none';
  }

  function lbOpen(idx) {
    if (!lightbox || !lbImages.length) return;
    lbIndex = ((idx % lbImages.length) + lbImages.length) % lbImages.length;
    lbRender();
    lightbox.classList.add('bsp-lightbox--open');
    document.body.style.overflow = 'hidden';
  }

  function lbClose() {
    if (!lightbox) return;
    lightbox.classList.remove('bsp-lightbox--open');
    document.body.style.overflow = '';
  }

  // Click on slide image → open
  document.querySelectorAll('.bsp-gallery__slide[data-full]').forEach(function(slide, i) {
    slide.addEventListener('click', function() { lbOpen(i); });
  });

  // Zoom button
  var zoomBtn = document.getElementById('bsp-zoom-btn');
  if (zoomBtn) {
    zoomBtn.addEventListener('click', function(e) {
      e.stopPropagation();
      var active = document.querySelector('.bsp-gallery__slide--active[data-full]');
      var idx = active ? lbImages.findIndex(function(x) { return x.src === active.dataset.full; }) : 0;
      lbOpen(idx >= 0 ? idx : 0);
    });
  }

  // Close button
  var lbCloseBtn = lightbox && lightbox.querySelector('.bsp-lightbox__close');
  if (lbCloseBtn) lbCloseBtn.addEventListener('click', lbClose);

  // Nav buttons
  if (lbPrev) lbPrev.addEventListener('click', function(e) {
    e.stopPropagation();
    lbIndex = (lbIndex - 1 + lbImages.length) % lbImages.length;
    lbRender();
  });
  if (lbNext) lbNext.addEventListener('click', function(e) {
    e.stopPropagation();
    lbIndex = (lbIndex + 1) % lbImages.length;
    lbRender();
  });

  // Click backdrop to close
  if (lightbox) {
    lightbox.addEventListener('click', function(e) {
      if (e.target === lightbox) lbClose();
    });
  }

  // Keyboard navigation
  document.addEventListener('keydown', function(e) {
    if (!lightbox || !lightbox.classList.contains('bsp-lightbox--open')) return;
    if (e.key === 'Escape')     lbClose();
    if (e.key === 'ArrowLeft')  { lbIndex = (lbIndex - 1 + lbImages.length) % lbImages.length; lbRender(); }
    if (e.key === 'ArrowRight') { lbIndex = (lbIndex + 1) % lbImages.length; lbRender(); }
  });

  // Touch swipe in lightbox
  var lbTouchX = 0;
  if (lightbox) {
    lightbox.addEventListener('touchstart', function(e) { lbTouchX = e.touches[0].clientX; }, { passive: true });
    lightbox.addEventListener('touchend', function(e) {
      var diff = lbTouchX - e.changedTouches[0].clientX;
      if (Math.abs(diff) > 50) {
        lbIndex = diff > 0
          ? (lbIndex + 1) % lbImages.length
          : (lbIndex - 1 + lbImages.length) % lbImages.length;
        lbRender();
      }
    }, { passive: true });
  }

  // ── Wishlist toggle (UI only) ──────────────────────────
  document.querySelectorAll('.bsp-gallery__wishlist, .bsp-wishlist-btn').forEach(function (btn) {
    btn.addEventListener('click', function () {
      this.classList.toggle('bsp-gallery__wishlist--active');
      this.classList.toggle('bsp-wishlist-btn--active');
    });
  });

  // ── Helpful button toggle ──────────────────────────────
  document.querySelectorAll('.bsp-helpful-btn').forEach(function (btn) {
    btn.addEventListener('click', function () {
      if (this.dataset.voted) return;
      var parts  = this.textContent.split(' ');
      var count  = parseInt(parts[parts.length - 1], 10);
      parts[parts.length - 1] = (count + 1).toString();
      this.textContent  = parts.join(' ');
      this.dataset.voted = '1';
      this.style.borderColor = 'var(--bsp-accent)';
      this.style.color        = 'var(--bsp-accent)';
    });
  });

})();
